// @flow
import React from 'react';
import classnames from 'classnames';

import { TextSeeMore } from 'Components/frameworks/text-see-more/TextSeeMore.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';
import { type IconName } from 'Components/frameworks/icon/Icon.jsx';

import { themes } from './Introduction.themes';

export type IntroductionProps = {
  className?: string,
  dataTestId?: string,
  iconName?: IconName,
  isTextSeeMoreCollapseEnabled?: boolean,
  seeLessLabel?: string,
  seeMoreLabel?: string,
  small?: string,
  subtitle?: string,
  text?: string,
  theme?: string,
  title?: string,
};

export function Introduction({
  className,
  dataTestId,
  iconName,
  isTextSeeMoreCollapseEnabled,
  seeLessLabel,
  seeMoreLabel,
  small,
  subtitle,
  text,
  theme = 'default',
  title,
}: IntroductionProps) {
  const hasHeading = !!title || !!subtitle;
  const hasText = !!text;

  if (!hasHeading && !hasText) {
    return null;
  }

  const { thLeft, thRight, thRoot, thSmall, thSubtitle, thSubtitleTheme, thTitleTheme } = themes[
    theme
  ];

  return (
    <div className={classnames(className, thRoot)} data-testid={dataTestId}>
      {hasHeading && (
        <div className={thLeft}>
          <Title hLevel={2} iconName={iconName} theme={thTitleTheme}>
            {title}
            {!!small && <small className={thSmall}>{small}</small>}
          </Title>
          <Title className={thSubtitle} hLevel={3} theme={thSubtitleTheme}>
            {subtitle}
          </Title>
        </div>
      )}
      {hasText && (
        <div className={thRight}>
          <TextSeeMore
            isCollapseEnabled={isTextSeeMoreCollapseEnabled}
            seeLessLabel={seeLessLabel}
            seeMoreLabel={seeMoreLabel}
            text={text}
          />
        </div>
      )}
    </div>
  );
}
